(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Desktop dropdown logic
  function initDesktopDropdowns() {
    const dropdowns = document.querySelectorAll('.js-nav-dropdown');
    let activeMenu = null;
    let timeoutId;

    const hideMenu = (menu) => {
      if (!menu) return;
      const dropdown = menu.closest('.js-nav-dropdown');
      menu.classList.remove('opacity-100', 'visible', 'translate-y-0');
      menu.classList.add('opacity-0', 'invisible', '-translate-y-4');
      if (dropdown) dropdown.classList.remove('is-open');
      if (activeMenu === menu) activeMenu = null;
    };

    dropdowns.forEach(dropdown => {
      const menu = dropdown.querySelector('.dropdown-menu');
      if (!menu) return;

      dropdown.addEventListener('mouseenter', () => {
        clearTimeout(timeoutId);
        if (activeMenu && activeMenu !== menu) hideMenu(activeMenu);
        menu.classList.remove('opacity-0', 'invisible', '-translate-y-4');
        menu.classList.add('opacity-100', 'visible', 'translate-y-0');
        dropdown.classList.add('is-open');
        activeMenu = menu;
      });

      const startHideTimeout = () => {
        timeoutId = setTimeout(() => hideMenu(menu), 200);
      };

      dropdown.addEventListener('mouseleave', startHideTimeout);
      menu.addEventListener('mouseenter', () => clearTimeout(timeoutId));
      menu.addEventListener('mouseleave', startHideTimeout);
    });
  }

  // Scroll handling - DISABLED FOR TESTING
  function initScrollHandling() {
    // Scroll animation disabled to test if it interferes with mobile menu
    return;
    
    const header = document.getElementById('main-header');
    if (!header) return;
    
    let lastScrollTop = 0;
    let scrolling = false;
    let headerOffset = 0;
    
    const isMobile = window.innerWidth < 1024;
    const maxHeaderOffset = isMobile ? 64 : 80;
    const scrollTrigger = isMobile ? 20 : 50;

    function handleScroll() {
      if (!scrolling) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollDelta = scrollTop - lastScrollTop;
          const isDropdownOpen = !!document.querySelector('.js-nav-dropdown.is-open');

          if (isDropdownOpen || scrollTop <= scrollTrigger) {
            headerOffset = 0;
            header.style.transform = 'translateY(0px)';
            lastScrollTop = scrollTop;
            scrolling = false;
            return;
          }

          const scrollThreshold = isMobile ? 1 : 2;
          if (Math.abs(scrollDelta) > scrollThreshold) {
            if (scrollDelta > 0) {
              const multiplier = isMobile ? 1.0 : 0.8;
              headerOffset = Math.min(headerOffset + Math.abs(scrollDelta) * multiplier, maxHeaderOffset);
            } else {
              const multiplier = isMobile ? 1.5 : 1.2;
              headerOffset = Math.max(headerOffset - Math.abs(scrollDelta) * multiplier, 0);
            }
            header.style.transform = `translateY(-${headerOffset}px)`;
          }

          lastScrollTop = scrollTop;
          scrolling = false;
        });
        scrolling = true;
      }
    }

    window.addEventListener('scroll', handleScroll);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initDesktopDropdowns();
      initScrollHandling();
    });
  } else {
    initDesktopDropdowns();
    initScrollHandling();
  }

  } catch(e) { console.error(e); }
})();
})();
